/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST =
  'DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST';
export const DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST_SUCCESS =
  'DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST_SUCCESS';
export const DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST_FAILURE =
  'DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST_FAILURE';

export const DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST =
  'DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST';
export const DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST_SUCCESS =
  'DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST_SUCCESS';
export const DOCUMENT_SIGNATURE_COORDINATES_UPSERT_REQUEST_FAILURE =
  'DOCUMENT_SIGNATURE_COORDINATES_FETCH_REQUEST_FAILURE';

export const FETCH_TAX_AUTHORIXATION_YEARS_REQUEST = 'FETCH_TAX_AUTHORIXATION_YEARS_REQUEST';
export const FETCH_TAX_AUTHORIXATION_YEARS_REQUEST_SUCCESS =
  'FETCH_TAX_AUTHORIXATION_YEARS_REQUEST_SUCCESS';
export const FETCH_TAX_AUTHORIXATION_YEARS_REQUEST_FAILURE =
  'FETCH_TAX_AUTHORIXATION_YEARS_REQUEST_FAILURE';

export const SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST = 'SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST';
export const SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST_SUCCESS =
  'SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST_SUCCESS';
export const SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST_FAILURE =
  'SINGLE_TAX_AUTHORIZATION_FETCH_REQUEST_FAILURE';

export const CLEAN_DOCUMENT_SIGNATURE_COORDINATES_PROPS =
  'CLEAN_DOCUMENT_SIGNATURE_COORDINATES_PROPS';

export const CLEAN_DOCUMENT_ERROR_IN_SIGNTAURE_UPLOAD = 'CLEAN_DOCUMENT_ERROR_IN_SIGNTAURE_UPLOAD';
